import { render } from "./CreateCustomerBatchModal.vue?vue&type=template&id=25ca96f3"
import script from "./CreateCustomerBatchModal.vue?vue&type=script&lang=js"
export * from "./CreateCustomerBatchModal.vue?vue&type=script&lang=js"

import exportComponent from "/app/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__